/*!
 * @monogrid/vue-boost v8.0.1 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
import l from "./index4.mjs";
import { LanguageSwitcher as b } from "./index4.mjs";
import { resolveComponent as s, openBlock as t, createElementBlock as n, Fragment as c, renderList as i, renderSlot as m, createBlock as p, withCtx as u, createTextVNode as d, toDisplayString as f, createCommentVNode as _ } from "vue";
import g from "./index5.mjs";
const h = {
  key: 0,
  class: "language-switcher"
};
function C(e, L, $, k, w, B) {
  const a = s("RouterLink");
  return e.locales && e.i18n ? (t(), n("nav", h, [
    (t(!0), n(c, null, i(e.locales, (r, o) => m(e.$slots, "default", {
      isCurrent: e.i18n.locale.value === o,
      localeCode: o,
      localeLabel: r.name
    }, () => [
      (t(), p(a, {
        key: o,
        to: { params: { locale: o } }
      }, {
        default: u(() => [
          d(f(r.name), 1)
        ]),
        _: 2
      }, 1032, ["to"]))
    ])), 256))
  ])) : _("", !0);
}
const N = /* @__PURE__ */ g(l, [["render", C]]);
export {
  b as LanguageSwitcher,
  N as default
};
